import React from 'react';
import { KompisSheet } from '@inter-ikea-kompis/react-components';
import { SheetAlignmentEnum } from '@inter-ikea-kompis/component-sheet';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

type Props = {
  visible: boolean;
  children: React.ReactNode;
  onOverlayClick?: () => void;
  onAnimationEnd?: () => void;
  zIndex?: number;
};

const Sheet = ({ visible, children, onOverlayClick, onAnimationEnd, zIndex, ...props }: Props) => {
  return (
    <KompisSheet
      {...props}
      theme={SkapaTheme}
      onOverlayClick={onOverlayClick}
      visible={visible}
      sheetAlignment={SheetAlignmentEnum.right} // Override skapa RTL to always keep menu to the right
      onAnimationEnd={onAnimationEnd}
      zIndex={zIndex}
    >
      {children}
    </KompisSheet>
  );
};

export default Sheet;
